import React from "react";
import { HashLink as Link } from "react-router-hash-link";
import { text } from "../../coreComponentsConfig";
import Typography from "../../Typography";

const NavItem = (props) => {
  const { href, children } = props;
  const isExternal = href.startsWith("http");

  if (isExternal) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
        <Typography {...text.smallText1}>{children}</Typography>
      </a>
    );
  }

  return (
    <Link to={href} smooth>
      <Typography {...text.smallText1}>{children}</Typography>
    </Link>
  );
};

export default React.memo(NavItem);
